import CompanyRoutes from "../../apiRoutes/CompanyRoutes";
import { api, GET, POST, POST_JSON } from "../ConsumeApiController";

export async function getOrders()
{
    let response = await GET(CompanyRoutes.Orders.GetOrders);
    return response;
}

export async function getOrderDetails(code)
{
    let response = await api.get(CompanyRoutes.Orders.GetOrdersDetails(code)) //GET(CompanyRoutes.Orders.GetOrdersDetails+code);
    return response;
}

export async function updateOrderStatus(id_pedido,id_estatus)
{
    const params = [
        {name:'id_pedido',value:id_pedido},
        {name:'id_estatus',value:id_estatus},
    ];

    let response = await POST(CompanyRoutes.Orders.UpdateOrderStatus,params);
    return response;
}



export async function getPaymentDestinations()
{
    const response = await api.get(CompanyRoutes.Orders.GetOrderPaymentDestinations);
    return response;
}

export async function registerManualPayment(orderId, manualPaymentData)
{
    const url = CompanyRoutes.Orders.InsertManualPayment(orderId);
    const response = await api.post(url,manualPaymentData);
    return response;
}